(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.cbaReady) return;
      root.dataset.cbaReady = '1';
      var track = root.querySelector('[data-cba-track]');
      if (!track) return;
      var section = root.closest('.cba');
      var prev = root.querySelector('[data-cba-prev]');
      var next = root.querySelector('[data-cba-next]');
      var dots = section ? section.querySelectorAll('[data-cba-dot]') : [];
      function slides() {
        return Array.prototype.filter.call(track.children, function (el) {
          return !/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(el.tagName);
        });
      }
      function current() {
        var w = track.clientWidth || 1;
        return Math.round(track.scrollLeft / w);
      }
      var index = 0;
      function go(i) {
        var s = slides();
        if (!s.length) return;
        i = Math.max(0, Math.min(s.length - 1, i));
        index = i;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        paint();
      }
      function update() {
        index = current();
        paint();
      }
      function paint() {
        var i = index;
        var n = slides().length;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= n - 1;
        Array.prototype.forEach.call(dots, function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-cba-dot'), 10)); });
      });
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 120); }, { passive: true });
      window.addEventListener('resize', function () { track.scrollTo({ left: index * track.clientWidth }); });
      update();
    }
    function run() { document.querySelectorAll('[data-cba]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /**
   * Return-to-grid: when the shopper comes back from a PDP, put the card they
   * clicked back under their eye instead of dumping them at the top.
   *
   * product-card.js writes the clicked card's anchor and page number into the
   * history entry before navigating away, so the back entry is ?page=N#<anchor>.
   *
   * Why this is not a one-line scrollIntoView, measured on a real collection:
   *
   *  - On a bfcache hit the whole DOM comes back and everything is already
   *    correct. Nothing to do.
   *  - On a COLD load of ?page=2 the server renders only that page's 24 cards,
   *    then the infinite-scroll observer prepends page 1 above them - inserting
   *    a full page of cards ABOVE the target and pushing it down. Measured: the
   *    card ended up 397px off centre when the scroll ran before that prepend.
   *  - Lazy images, font swap and the per-card entry transition all reflow the
   *    grid for a while after first paint.
   *
   * So the position is re-asserted from two directions: a short rAF loop that
   * converges on first paint, and observers that fire whenever the grid itself
   * changes - a MutationObserver for inserted cards (this is what catches the
   * page-1 prepend, and it still fires in a throttled/background tab where rAF
   * does not) and a ResizeObserver for height changes from images.
   *
   * Guards: everything stops the moment the shopper actually interacts, and the
   * whole thing switches off after WATCH_MS so it can never fight a real user.
   * Deliberately NOT listening for 'scroll' - scrollIntoView fires that itself,
   * so it would abort on its own first correction.
   */
  (() => {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (_) {
      return;
    }

    const SETTLE_FRAMES = 5;
    const TOLERANCE_PX = 2;
    const WATCH_MS = 8000;

    let done = false;
    const observers = [];
    const stop = () => {
      if (done) return;
      done = true;
      for (const o of observers) o.disconnect();
    };

    for (const evt of ['wheel', 'touchmove', 'keydown', 'pointerdown']) {
      window.addEventListener(evt, stop, { passive: true });
    }
    setTimeout(stop, WATCH_MS);

    const findCard = () => {
      const target = document.getElementById(id);
      if (!target) return null;
      return target.closest('.product-grid__item') || target;
    };

    /**
     * @returns {boolean} true when the card is already centred
     */
    const centreCard = () => {
      const card = findCard();
      if (!card) return false;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const rect = card.getBoundingClientRect();
      if (Math.abs(rect.top + rect.height / 2 - viewportHeight / 2) <= TOLERANCE_PX) return true;
      card.scrollIntoView({ behavior: 'instant', block: 'center' });
      return false;
    };

    const settle = () => {
      let settledFrames = 0;
      const tick = () => {
        if (done) return;
        settledFrames = centreCard() ? settledFrames + 1 : 0;
        if (settledFrames < SETTLE_FRAMES) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const start = () => {
      settle();

      const grid = document.querySelector('.product-grid');
      if (grid) {
        // Cards inserted above the target (the page-1 prepend) shift it down.
        const mo = new MutationObserver(() => {
          if (!done) settle();
        });
        mo.observe(grid, { childList: true });
        observers.push(mo);

        if (typeof ResizeObserver === 'function') {
          let first = true;
          const ro = new ResizeObserver(() => {
            if (first) {
              first = false;
              return;
            }
            if (!done) settle();
          });
          ro.observe(grid);
          observers.push(ro);
        }
      }

      window.addEventListener(
        'load',
        () => {
          if (!done) settle();
        },
        { once: true }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
